export const FETCH_ACTIVE_FORMS_REQUEST = 'FETCH_ACTIVE_FORMS_REQUEST'
export const FETCH_ACTIVE_FORMS_SUCCESS = 'FETCH_ACTIVE_FORMS_SUCCESS'
export const FETCH_ACTIVE_FORMS_FAIL = 'FETCH_ACTIVE_FORMS_FAIL'

export const PICK_VOLUNTEER_FORM_REQUEST = 'PICK_VOLUNTEER_FORM_REQUEST'
export const PICK_VOLUNTEER_FORM_SUCCESS = 'PICK_VOLUNTEER_FORM_SUCCESS'
export const PICK_VOLUNTEER_FORM_FAIL = 'PICK_VOLUNTEER_FORM_FAIL'
export const PICK_VOLUNTEER_FORM_RESET = 'PICK_VOLUNTEER_FORM_RESET'

export const FETCH_PICKED_FORMS_REQUEST = 'FETCH_PICKED_FORMS_REQUEST'
export const FETCH_PICKED_FORMS_SUCCESS = 'FETCH_PICKED_FORMS_SUCCESS'
export const FETCH_PICKED_FORMS_FAIL = 'FETCH_PICKED_FORMS_FAIL'

export const FETCH_FORM_BY_ID_REQUEST = 'FETCH_FORM_BY_ID_REQUEST'
export const FETCH_FORM_BY_ID_SUCCESS = 'FETCH_FORM_BY_ID_SUCCESS'
export const FETCH_FORM_BY_ID_FAIL = 'FETCH_FORM_BY_ID_FAIL'

export const APPROVE_VOLUNTEER_REQUEST = 'APPROVE_VOLUNTEER_REQUEST'
export const APPROVE_VOLUNTEER_SUCCESS = 'APPROVE_VOLUNTEER_SUCCESS'
export const APPROVE_VOLUNTEER_FAIL = 'APPROVE_VOLUNTEER_FAIL'

export const DECLINE_VOLUNTEER_REQUEST = 'DECLINE_VOLUNTEER_REQUEST'
export const DECLINE_VOLUNTEER_SUCCESS = 'DECLINE_VOLUNTEER_SUCCESS'
export const DECLINE_VOLUNTEER_FAIL = 'DECLINE_VOLUNTEER_FAIL'